module.exports = __webpack_public_path__ + "static/media/Neuro.9762e0d3.jpeg";